<template>
  <div>
    <!-- 配列をカンマ区切りで表示 -->
    <p>{{ formattedData }}</p>
  </div>
</template>

<script>

export default {
  props: {
    items: {
      type: Array
    },
  },
  computed: {
    // 配列をカンマ区切りに変換する
    formattedData() {
      return this.items.join(", ");
    },
  },
}
</script>
